(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp4-business-banner"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const focusableSelector = [
      'a[href]',
      'button:not([disabled])',
      'textarea:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ].join(',')

    let bodyScrollY = 0
    let activeModal = null
    let previousFocus = null
    let isolatedElements = []
    const controller = new AbortController()
    const scrollLockClass = 'lp4-comparison-popup-scroll-lock'
    const scrollTopProperty = '--lp4-comparison-popup-scroll-top'

    const isDesignMode = () => Boolean(window.Shopify && window.Shopify.designMode)
    const isCurrentListener = () => !controller.signal.aborted

    const getFocusable = (modal) =>
      Array.from(modal.querySelectorAll(focusableSelector)).filter((element) => {
        return (
          element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
        )
      })

    const scrollExpandedAccordionToTop = (accordionItem, accordionRoot) => {
      if (!accordionItem || !accordionRoot) return
      if (!window.matchMedia('(max-width: 989px)').matches) return

      const list = accordionRoot.querySelector('.lp4-comparison-popup-mobile-compare__list')
      if (!list) return

      const listRect = list.getBoundingClientRect()
      const itemRect = accordionItem.getBoundingClientRect()
      const targetTop = list.scrollTop + itemRect.top - listRect.top
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

      list.scrollTo({
        top: targetTop,
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      })
    }

    const lockBody = (scrollY) => {
      bodyScrollY = Number.isFinite(scrollY)
        ? scrollY
        : window.scrollY || document.documentElement.scrollTop || 0
      document.body.style.setProperty(scrollTopProperty, `-${bodyScrollY}px`)
      document.body.classList.add(scrollLockClass)
    }

    const unlockBody = (scrollY) => {
      const targetScrollY = Number.isFinite(scrollY) ? scrollY : bodyScrollY
      document.body.classList.remove(scrollLockClass)
      document.body.style.removeProperty(scrollTopProperty)
      window.scrollTo(0, targetScrollY)
    }

    const isolateBackground = (modal) => {
      isolatedElements = []
      let current = modal

      while (current && current !== document.body) {
        const parent = current.parentElement
        if (!parent) break

        Array.from(parent.children)
          .filter((element) => element !== current)
          .forEach((element) => {
            isolatedElements.push({
              element,
              inert: element.inert,
              ariaHidden: element.getAttribute('aria-hidden'),
            })
          })
        current = parent
      }

      isolatedElements.forEach(({ element }) => {
        element.inert = true
        element.setAttribute('aria-hidden', 'true')
      })
    }

    const restoreBackground = () => {
      isolatedElements.forEach(({ element, inert, ariaHidden }) => {
        element.inert = inert
        if (ariaHidden === null) element.removeAttribute('aria-hidden')
        else element.setAttribute('aria-hidden', ariaHidden)
      })
      isolatedElements = []
    }

    const openModal = (modal, trigger) => {
      if (!modal || activeModal === modal) return

      previousFocus = trigger || document.activeElement
      modal.hidden = false
      activeModal = modal
      lockBody()
      isolateBackground(modal)

      window.requestAnimationFrame(() => {
        const closeButton = modal.querySelector(
          '[data-lp4-comparison-popup-close]:not(.lp4-comparison-popup-modal__overlay)',
        )
        const body = modal.querySelector('[data-lp4-comparison-popup-body]')
        ;(body || closeButton || modal).focus({ preventScroll: true })
      })
    }

    const closeModal = (modal) => {
      const targetModal = modal || activeModal
      if (!targetModal) return

      targetModal.hidden = true
      activeModal = null
      unlockBody()
      restoreBackground()

      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus({ preventScroll: true })
      }
      previousFocus = null
    }

    const findModalForTrigger = (trigger) => {
      const targetId =
        trigger.getAttribute('aria-controls') ||
        trigger.getAttribute('data-lp4-comparison-popup-target')
      if (targetId) return document.getElementById(targetId)

      const root = trigger.closest('[data-lp4-comparison-popup-root]')
      return root
        ? root.querySelector('[data-lp4-comparison-popup-modal]')
        : document.querySelector('[data-lp4-comparison-popup-modal]')
    }

    const getEventElement = (event) => {
      const target = event.target
      if (target instanceof Element) return target
      return target && target.parentElement ? target.parentElement : null
    }

    const toggleAccordionPanel = (accordionTrigger, event) => {
      if (event) {
        event.preventDefault()
        event.stopPropagation()
      }

      const modal = accordionTrigger.closest('[data-lp4-comparison-popup-modal]')
      const accordionRoot =
        accordionTrigger.closest('[data-lp4-comparison-popup-mobile-compare]') || modal
      const accordionItem = accordionTrigger.closest('.lp4-comparison-popup-mobile-compare__item')
      let panel = accordionItem
        ? accordionItem.querySelector('[data-lp4-comparison-popup-accordion-panel]')
        : null

      if (!panel && modal) {
        const panelId = accordionTrigger.getAttribute('aria-controls')
        panel = panelId ? modal.querySelector(`[id="${panelId}"]`) : null
      }

      if (!modal || !accordionRoot || !panel) return

      const nextExpanded = accordionTrigger.getAttribute('aria-expanded') !== 'true'
      accordionRoot
        .querySelectorAll('[data-lp4-comparison-popup-accordion-trigger]')
        .forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false')
        })
      accordionRoot
        .querySelectorAll('[data-lp4-comparison-popup-accordion-panel]')
        .forEach((item) => {
          item.hidden = true
        })

      accordionTrigger.setAttribute('aria-expanded', String(nextExpanded))
      panel.hidden = !nextExpanded

      if (nextExpanded && accordionItem) {
        window.requestAnimationFrame(() => {
          scrollExpandedAccordionToTop(accordionItem, accordionRoot)
        })
      }
    }

    const bindAccordionTriggers = (root) => {
      ;(root || document)
        .querySelectorAll('[data-lp4-comparison-popup-accordion-trigger]')
        .forEach((trigger) => {
          trigger.onclick = (event) => toggleAccordionPanel(trigger, event)
        })
    }

    bindAccordionTriggers()

    document.addEventListener('click', (event) => {
      if (!isCurrentListener()) return

      const eventTarget = getEventElement(event)
      if (!eventTarget) return

      const openTrigger = eventTarget.closest('[data-lp4-comparison-popup-open]')
      if (openTrigger) {
        event.preventDefault()
        openModal(findModalForTrigger(openTrigger), openTrigger)
        return
      }

      const closeTrigger = eventTarget.closest('[data-lp4-comparison-popup-close]')
      if (closeTrigger) {
        event.preventDefault()
        closeModal(closeTrigger.closest('[data-lp4-comparison-popup-modal]'))
        return
      }

      const accordionTrigger = eventTarget.closest('[data-lp4-comparison-popup-accordion-trigger]')
      if (accordionTrigger) {
        toggleAccordionPanel(accordionTrigger, event)
        return
      }
    }, { signal: controller.signal })

    document.addEventListener('keydown', (event) => {
      if (!isCurrentListener()) return
      if (!activeModal) return

      if (event.key === 'Escape') {
        event.preventDefault()
        closeModal(activeModal)
        return
      }

      if (event.key !== 'Tab') return

      const focusable = getFocusable(activeModal)
      if (!focusable.length) {
        event.preventDefault()
        activeModal.focus()
        return
      }

      const first = focusable[0]
      const last = focusable[focusable.length - 1]

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }, { signal: controller.signal })

    document.addEventListener('shopify:block:select', (event) => {
      if (!isCurrentListener()) return
      if (!isDesignMode()) return

      const root = event.target.closest('[data-lp4-comparison-popup-root]')
      const modal = root ? root.querySelector('[data-lp4-comparison-popup-modal]') : null
      if (!modal) return

      if (modal.hidden) openModal(modal)
    }, { signal: controller.signal })

    document.addEventListener('shopify:section:load', (event) => {
      if (!isCurrentListener()) return
      if (!isDesignMode()) return
      bindAccordionTriggers(event.target)
    }, { signal: controller.signal })

    document.addEventListener('shopify:section:unload', (event) => {
      if (!isCurrentListener()) return
      const root = activeModal?.closest('[data-lp4-comparison-popup-root]')
      if (activeModal && root && event.target.contains(root)) closeModal(activeModal)
      event.target
        .querySelectorAll('[data-lp4-comparison-popup-accordion-trigger]')
        .forEach((trigger) => {
          trigger.onclick = null
        })
    }, { signal: controller.signal })

    window.addEventListener(
      'pagehide',
      () => {
        if (activeModal) closeModal(activeModal)
        controller.abort()
      },
      { once: true, signal: controller.signal },
    )
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-faq"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const initFaq = (root) => {
      if (!root) return
      root['lp4FaqCleanup']?.()

      const controller = new AbortController()
      root.dataset.lp4FaqReady = 'true'

      root.addEventListener(
        'click',
        (event) => {
          const trigger = event.target.closest('[data-lp4-faq-trigger]')
          if (!trigger || !root.contains(trigger)) return
          const item = trigger.closest('.lp4-faq__item')
          const panel = item && item.querySelector('[data-lp4-faq-panel]')
          if (!item || !panel) return

          const open = !item.classList.contains('is-active')
          item.classList.toggle('is-active', open)
          trigger.setAttribute('aria-expanded', String(open))
          panel.hidden = !open
        },
        { signal: controller.signal },
      )

      root['lp4FaqCleanup'] = () => {
        controller.abort()
        delete root.dataset.lp4FaqReady
        delete root['lp4FaqCleanup']
      }

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(root)) root['lp4FaqCleanup']?.()
        },
        { signal: controller.signal },
      )
    }

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-lp4-faq]').forEach(initFaq)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target))
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-lds-workflow"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const prewarmMedia = (scope) => {
      if (!scope) return

      scope.querySelectorAll('img').forEach((img) => {
        img.loading = 'eager'
        if (img.dataset.lp4Prewarmed === 'true') return
        img.dataset.lp4Prewarmed = 'true'

        const preloader = new Image()
        preloader.decoding = 'async'
        preloader.sizes = img.sizes || img.getAttribute('sizes') || '100vw'
        if (img.srcset) preloader.srcset = img.srcset
        preloader.src = img.currentSrc || img.src
        if (preloader.decode) preloader.decode().catch(() => {})
      })

      if (scope.querySelector('video[data-responsive-video]')) {
        document.dispatchEvent(
          new CustomEvent('responsive-video:prepare', {
            detail: { root: scope, options: { play: false } },
          }),
        )
      }
    }

    const setActiveDot = (dots, index) => {
      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index)
      })
    }

    const initRoot = (root) => {
      if (!root) return
      root['lp4LdsWorkflowCleanup']?.()

      const controller = new AbortController()
      root.dataset.lp4LdsWorkflowReady = 'true'

      const tabs = Array.from(root.querySelectorAll('[data-lp4-lds-workflow-tab]'))
      const panels = Array.from(root.querySelectorAll('[data-lp4-lds-workflow-panel]'))
      const panelsViewport = root.querySelector('[data-lp4-lds-workflow-panels]')
      const mobileQuery = window.matchMedia('(max-width: 749px)')
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
      const USE_CASE_SCROLL_PADDING = 23.5
      let useCaseScrollLock = false
      let useCaseScrollLockTimer = 0
      let useCaseScrollEndTimer = 0
      let prewarmIdle = 0
      let prewarmTimer = 0
      let legacyMobileQueryListener = false

      const releaseUseCaseScrollLock = () => {
        useCaseScrollLock = false
        syncUseCaseFromScrollPosition()
      }

      const lockUseCaseScroll = (behavior) => {
        useCaseScrollLock = true
        window.clearTimeout(useCaseScrollLockTimer)

        if (behavior === 'auto') {
          useCaseScrollLock = false
          return
        }

        if ('onscrollend' in (panelsViewport || {})) {
          panelsViewport.addEventListener('scrollend', releaseUseCaseScrollLock, {
            once: true,
            signal: controller.signal,
          })
          return
        }

        useCaseScrollLockTimer = window.setTimeout(releaseUseCaseScrollLock, 450)
      }

      const syncUseCaseFromScrollPosition = () => {
        if (!mobileQuery.matches || !panelsViewport || panels.length === 0) return

        const viewportCenter = panelsViewport.scrollLeft + panelsViewport.clientWidth / 2
        const activePanel = panels.reduce(
          (closest, panel) => {
            const center = panel.offsetLeft + panel.offsetWidth / 2
            const distance = Math.abs(center - viewportCenter)
            return distance < closest.distance ? { distance, panel } : closest
          },
          { distance: Number.POSITIVE_INFINITY, panel: panels[0] },
        ).panel

        if (activePanel) setUseCaseActive(activePanel.dataset.lp4LdsWorkflowPanel)
      }

      const setUseCaseActive = (target, options = {}) => {
        const targetPanel = root.querySelector(`[data-lp4-lds-workflow-panel="${target}"]`)
        prewarmMedia(targetPanel)

        tabs.forEach((item) => {
          const active = item.dataset.lp4LdsWorkflowTab === target
          item.classList.toggle('is-active', active)
          item.setAttribute('aria-selected', String(active))
        })

        panels.forEach((panel) => {
          const active = panel.dataset.lp4LdsWorkflowPanel === target
          panel.classList.toggle('is-active', active)
          panel.hidden = mobileQuery.matches ? false : !active
        })

        if (options.scroll && mobileQuery.matches && targetPanel && panelsViewport) {
          const behavior = options.instant || reducedMotion.matches ? 'auto' : 'smooth'
          lockUseCaseScroll(behavior)
          panelsViewport.scrollTo({
            left: targetPanel.offsetLeft - USE_CASE_SCROLL_PADDING,
            behavior,
          })
        }
      }

      const syncUseCaseVisibility = () => {
        const activeTab = tabs.find((tab) => tab.classList.contains('is-active')) || tabs[0]
        if (activeTab) setUseCaseActive(activeTab.dataset.lp4LdsWorkflowTab, { instant: true })
      }

      tabs.forEach((tab) => {
        tab.addEventListener(
          'click',
          () => {
            const target = tab.dataset.lp4LdsWorkflowTab
            setUseCaseActive(target, { scroll: true })
          },
          { signal: controller.signal },
        )

        tab.addEventListener(
          'pointerover',
          () => {
            prewarmMedia(
              root.querySelector(
                `[data-lp4-lds-workflow-panel="${tab.dataset.lp4LdsWorkflowTab}"]`,
              ),
            )
          },
          { passive: true, signal: controller.signal },
        )
      })

      if (panelsViewport && panels.length) {
        const updateUseCaseFromScroll = () => {
          window.clearTimeout(useCaseScrollEndTimer)
          useCaseScrollEndTimer = window.setTimeout(() => {
            if (useCaseScrollLock) return
            syncUseCaseFromScrollPosition()
          }, 120)
        }

        panelsViewport.addEventListener('scroll', updateUseCaseFromScroll, {
          passive: true,
          signal: controller.signal,
        })
      }

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', syncUseCaseVisibility, {
          signal: controller.signal,
        })
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(syncUseCaseVisibility)
        legacyMobileQueryListener = true
      }
      syncUseCaseVisibility()

      const prewarmPanels = () => {
        panels.forEach(prewarmMedia)
      }
      prewarmMedia(root.querySelector('[data-lp4-lds-workflow-panel].is-active') || root)
      if ('requestIdleCallback' in window) {
        prewarmIdle = window.requestIdleCallback(prewarmPanels, { timeout: 1600 })
      } else {
        prewarmTimer = window.setTimeout(prewarmPanels, 300)
      }

      const steps = root.querySelector('[data-lp4-lds-workflow-steps]')
      const stepItems = Array.from(root.querySelectorAll('[data-lp4-lds-workflow-step]'))
      const stepDots = Array.from(root.querySelectorAll('[data-lp4-lds-workflow-step-dot]'))
      const STEP_SCROLL_PADDING = 23.5
      const STEP_GAP = 16
      let stepsScrollLock = false
      let stepsScrollLockTimer = 0
      let stepsFrame = 0

      const getStepIndexFromScroll = () => {
        if (!steps || stepItems.length === 0) return 0
        const stride = stepItems[0].offsetWidth + STEP_GAP
        if (!stride) return 0
        const index = Math.round((steps.scrollLeft - STEP_SCROLL_PADDING) / stride)
        return Math.max(0, Math.min(stepDots.length - 1, index))
      }

      const setStepDotActive = (index) => {
        setActiveDot(stepDots, index)
        stepDots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false')
        })
      }

      const releaseStepsScrollLock = () => {
        stepsScrollLock = false
        setStepDotActive(getStepIndexFromScroll())
      }

      const scrollToStep = (index, behavior = 'smooth') => {
        const item = stepItems[index]
        if (!steps || !item) return

        const resolvedBehavior = reducedMotion.matches ? 'auto' : behavior

        stepsScrollLock = true
        window.clearTimeout(stepsScrollLockTimer)
        setStepDotActive(index)

        steps.scrollTo({
          left: Math.max(0, item.offsetLeft - STEP_SCROLL_PADDING),
          behavior: resolvedBehavior,
        })

        if (resolvedBehavior === 'auto') {
          stepsScrollLock = false
          return
        }

        if ('onscrollend' in steps) {
          steps.addEventListener('scrollend', releaseStepsScrollLock, {
            once: true,
            signal: controller.signal,
          })
          return
        }

        stepsScrollLockTimer = window.setTimeout(releaseStepsScrollLock, 450)
      }

      if (steps && stepItems.length && stepDots.length) {
        stepDots.forEach((dot, index) => {
          dot.addEventListener('click', () => scrollToStep(index), {
            signal: controller.signal,
          })
        })

        steps.addEventListener(
          'scroll',
          () => {
            window.cancelAnimationFrame(stepsFrame)
            stepsFrame = window.requestAnimationFrame(() => {
              if (stepsScrollLock) return
              setStepDotActive(getStepIndexFromScroll())
            })
          },
          { passive: true, signal: controller.signal },
        )

        setStepDotActive(getStepIndexFromScroll())
      }

      const preview = root.querySelector('[data-lp4-lds-workflow-preview]')
      if (preview) {
        preview.addEventListener(
          'click',
          () => {
            const video = preview.querySelector('video')
            if (!video) return
            document.dispatchEvent(
              new CustomEvent('responsive-video:prepare', {
                detail: { root: preview, options: { play: true } },
              }),
            )
            const promise = video.play()
            if (promise && typeof promise.catch === 'function') promise.catch(() => {})
          },
          { signal: controller.signal },
        )
      }

      root['lp4LdsWorkflowCleanup'] = () => {
        controller.abort()
        window.clearTimeout(useCaseScrollLockTimer)
        window.clearTimeout(useCaseScrollEndTimer)
        window.clearTimeout(stepsScrollLockTimer)
        window.clearTimeout(prewarmTimer)
        window.cancelAnimationFrame(stepsFrame)
        if (prewarmIdle && 'cancelIdleCallback' in window) {
          window.cancelIdleCallback(prewarmIdle)
        }
        if (legacyMobileQueryListener) mobileQuery.removeListener(syncUseCaseVisibility)
        root.querySelectorAll('video').forEach((video) => video.pause())
        delete root.dataset.lp4LdsWorkflowReady
        delete root['lp4LdsWorkflowCleanup']
      }

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(root)) root['lp4LdsWorkflowCleanup']?.()
        },
        { signal: controller.signal },
      )
    }

    const initAll = () => {
      document.querySelectorAll('[data-lp4-lds-workflow]').forEach(initRoot)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => {
      initRoot(event.target.querySelector('[data-lp4-lds-workflow]'))
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-material-switcher"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const prewarmMedia = (scope) => {
      if (!scope) return
      scope.querySelectorAll('img').forEach((img) => {
        img.loading = 'eager'
        if (img.dataset.lp4Prewarmed === 'true') return
        img.dataset.lp4Prewarmed = 'true'
        const preloader = new Image()
        preloader.decoding = 'async'
        if (img.srcset) preloader.srcset = img.srcset
        preloader.src = img.currentSrc || img.src
      })
      document.dispatchEvent(
        new CustomEvent('responsive-video:prepare', {
          detail: { root: scope, options: { play: false } },
        }),
      )
    }

    const getLaserKey = (panel) => panel?.dataset.lp4MaterialSwitcherLaserPanel || ''

    const getLaserPanelId = (panel) => panel?.dataset.lp4MaterialSwitcherLaserPanelId || ''

    const getLaserPanels = (root) =>
      Array.from(root.querySelectorAll('[data-lp4-material-switcher-laser-panel]'))

    const findLaserPanel = (root, target) => {
      if (!root || !target) return null

      const panels = getLaserPanels(root)
      return (
        panels.find((panel) => getLaserPanelId(panel) === target) ||
        panels.find((panel) => getLaserKey(panel) === target) ||
        null
      )
    }

    const activateLaserPanel = (root, targetPanel) => {
      if (!root || !targetPanel) return

      let matched = false
      getLaserPanels(root).forEach((panel) => {
        const active = panel === targetPanel
        matched = matched || active
        const trigger = panel.querySelector('[data-lp4-material-switcher-laser]')
        panel.classList.toggle('is-active', active)
        if (trigger) trigger.setAttribute('aria-expanded', String(active))
      })

      if (matched) syncMaterials(root, getLaserKey(targetPanel))
    }

    const activateLaser = (root, target) => {
      activateLaserPanel(root, findLaserPanel(root, target))
    }

    const initLaserStack = (root) => {
      if (!root) return
      root['lp4MaterialSwitcherCleanup']?.()

      const controller = new AbortController()
      root.dataset.lp4MaterialSwitcherLaserReady = 'true'

      root.addEventListener(
        'click',
        (event) => {
          const laser = event.target.closest('[data-lp4-material-switcher-laser]')
          if (!laser || !root.contains(laser)) return

          const panel = laser.closest('[data-lp4-material-switcher-laser-panel]')
          activateLaserPanel(root, panel)
        },
        { signal: controller.signal },
      )

      const activePanel = root.querySelector('[data-lp4-material-switcher-laser-panel].is-active')
      const initialPanel =
        activePanel || root.querySelector('[data-lp4-material-switcher-laser-panel]')
      activateLaserPanel(root, initialPanel)

      document.addEventListener(
        'shopify:block:select',
        (event) => {
          const selectedBlockId = event.detail?.blockId || ''
          const panel =
            event.target.closest('[data-lp4-material-switcher-laser-panel]') ||
            getLaserPanels(root).find((item) => getLaserPanelId(item) === selectedBlockId)
          if (panel && root.contains(panel)) activateLaserPanel(root, panel)
        },
        { signal: controller.signal },
      )

      root['lp4MaterialSwitcherCleanup'] = () => {
        controller.abort()
        delete root.dataset.lp4MaterialSwitcherLaserReady
        delete root['lp4MaterialSwitcherCleanup']
      }

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(root)) root['lp4MaterialSwitcherCleanup']?.()
        },
        { signal: controller.signal },
      )
    }

    const syncMaterials = (root, laserKey) => {
      const materialCard = root.querySelector('.lp4-material-switcher__material-card')
      if (!materialCard) return

      const tabs = Array.from(
        materialCard.querySelectorAll(
          '[data-lp4-tabs-trigger][data-lp4-material-switcher-material-laser]',
        ),
      )
      const panels = Array.from(
        materialCard.querySelectorAll(
          '[data-lp4-tabs-panel][data-lp4-material-switcher-material-laser]',
        ),
      )
      const visibleTabs = tabs.filter(
        (item) => item.dataset.lp4MaterialSwitcherMaterialLaser === laserKey,
      )
      const hasVisibleTabs = visibleTabs.length > 0

      materialCard.classList.toggle('is-empty', !hasVisibleTabs)
      root.classList.toggle('lp4-material-switcher--laser-only', !hasVisibleTabs)

      tabs.forEach((item) => {
        const visible = item.dataset.lp4MaterialSwitcherMaterialLaser === laserKey
        item.hidden = !visible
        if (!visible) {
          item.classList.remove('is-active')
          item.setAttribute('aria-selected', 'false')
        }
      })

      panels.forEach((item) => {
        const visible = item.dataset.lp4MaterialSwitcherMaterialLaser === laserKey
        item.hidden = !visible
        if (!visible) item.classList.remove('is-active')
      })

      if (!hasVisibleTabs) return

      const activeVisibleTab =
        visibleTabs.find((item) => item.classList.contains('is-active')) || visibleTabs[0]
      if (!activeVisibleTab) return

      const target = activeVisibleTab.dataset.lp4TabsTrigger
      tabs.forEach((item) => {
        const active = item === activeVisibleTab
        item.classList.toggle('is-active', active)
        item.setAttribute('aria-selected', String(active))
      })
      panels.forEach((item) => {
        const active = item.dataset.lp4TabsPanel === target
        item.classList.toggle('is-active', active)
        item.hidden = !active
        if (active) prewarmMedia(item)
      })
    }

    const initAll = () => {
      document.querySelectorAll('[data-lp4-material-switcher]').forEach(initLaserStack)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => {
      initLaserStack(event.target.querySelector('[data-lp4-material-switcher]'))
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-product-hero"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const initRoot = (root) => {
      if (!root) return
      root['lp4ProductHeroCleanup']?.()

      const controller = new AbortController()
      root.dataset.lp4ProductHeroVideoReady = 'true'

      const trigger = root.querySelector('[data-lp4-product-hero-video-trigger]')
      const modal = root.querySelector('[data-lp4-product-hero-video-modal]')
      const close = root.querySelector('[data-lp4-product-hero-video-close]')
      const video = modal && modal.querySelector('video[data-responsive-video]')
      const youtubeFrame = modal && modal.querySelector('[data-lp4-product-hero-youtube]')
      if (!trigger || !modal || !close || (!video && !youtubeFrame)) {
        controller.abort()
        delete root.dataset.lp4ProductHeroVideoReady
        return
      }
      const modalParent = modal.parentNode
      const modalNextSibling = modal.nextSibling
      let isolatedElements = []
      let previousFocus = null
      if (modal.parentElement !== document.body) document.body.appendChild(modal)

      const prepare = (play) => {
        document.dispatchEvent(
          new CustomEvent('responsive-video:prepare', {
            detail: { root: modal, options: { play } },
          }),
        )
      }

      const loadYouTube = () => {
        if (!youtubeFrame || youtubeFrame.querySelector('iframe')) return

        const iframe = document.createElement('iframe')
        iframe.src = youtubeFrame.dataset.youtubeSrc
        iframe.title = youtubeFrame.dataset.youtubeTitle || 'YouTube video player'
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        iframe.referrerPolicy = 'strict-origin-when-cross-origin'
        iframe.allowFullscreen = true
        youtubeFrame.appendChild(iframe)
      }

      const unloadYouTube = () => {
        if (!youtubeFrame) return
        youtubeFrame.textContent = ''
      }

      const isolateBackground = () => {
        isolatedElements = Array.from(document.body.children)
          .filter((element) => element !== modal && !element.contains(modal))
          .map((element) => ({
            element,
            inert: element.inert,
            ariaHidden: element.getAttribute('aria-hidden'),
          }))
        isolatedElements.forEach(({ element }) => {
          element.inert = true
          element.setAttribute('aria-hidden', 'true')
        })
      }

      const restoreBackground = () => {
        isolatedElements.forEach(({ element, inert, ariaHidden }) => {
          element.inert = inert
          if (ariaHidden === null) element.removeAttribute('aria-hidden')
          else element.setAttribute('aria-hidden', ariaHidden)
        })
        isolatedElements = []
      }

      const open = () => {
        previousFocus = document.activeElement
        modal.hidden = false
        document.documentElement.classList.add('lp4-video-modal-open')
        isolateBackground()
        if (youtubeFrame) {
          loadYouTube()
        } else {
          prepare(true)
        }
        close.focus({ preventScroll: true })
      }

      const closeModal = (restoreFocus = true) => {
        if (modal.hidden) return
        modal.hidden = true
        document.documentElement.classList.remove('lp4-video-modal-open')
        restoreBackground()
        if (video) video.pause()
        unloadYouTube()
        if (restoreFocus && previousFocus?.focus) previousFocus.focus({ preventScroll: true })
        previousFocus = null
      }

      if (video) {
        trigger.addEventListener('pointerover', () => prepare(false), {
          passive: true,
          signal: controller.signal,
        })
        trigger.addEventListener('focus', () => prepare(false), {
          signal: controller.signal,
        })
      }
      trigger.addEventListener('click', open, { signal: controller.signal })
      close.addEventListener('click', () => closeModal(), { signal: controller.signal })
      modal.addEventListener(
        'click',
        (event) => {
          if (event.target === modal) closeModal()
        },
        { signal: controller.signal },
      )
      document.addEventListener(
        'keydown',
        (event) => {
          if (modal.hidden) return
          if (event.key === 'Escape') {
            event.preventDefault()
            closeModal()
            return
          }
          if (event.key !== 'Tab') return
          const focusable = Array.from(
            modal.querySelectorAll(
              'button:not([disabled]), a[href], iframe, [tabindex]:not([tabindex="-1"])',
            ),
          )
          if (!focusable.length) return
          const first = focusable[0]
          const last = focusable[focusable.length - 1]
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault()
            last.focus()
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault()
            first.focus()
          }
        },
        { signal: controller.signal },
      )

      root['lp4ProductHeroCleanup'] = () => {
        closeModal(false)
        controller.abort()
        if (modalParent) modalParent.insertBefore(modal, modalNextSibling)
        delete root.dataset.lp4ProductHeroVideoReady
        delete root['lp4ProductHeroCleanup']
      }

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(root)) root['lp4ProductHeroCleanup']?.()
        },
        { signal: controller.signal },
      )
    }

    const initAll = (scope = document) => {
      scope.querySelectorAll('.lp4-product-hero').forEach(initRoot)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target))
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-side-navigation"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    let initialized = false
    let controller = null
    let scrollTicking = false
    let updateFrame = 0
    let clickLockTarget = ''
    let clickLockTimer = 0
    let firstMeasureTimer = 0
    let secondMeasureTimer = 0
    let stickyStart = 0
    const sideHiddenSelectors = ['.lp4-profit-cards']
    const cssVariableNames = [
      '--lp4-secondary-nav-top',
      '--lp4-secondary-nav-mobile-top',
      '--lp4-secondary-nav-dropdown-top',
    ]
    const originalCssVariables = new Map(
      cssVariableNames.map((name) => [name, document.documentElement.style.getPropertyValue(name)]),
    )

    const resolveTarget = (selector) => {
      if (!selector) return null
      try {
        return document.querySelector(selector)
      } catch (_) {
        return null
      }
    }

    const getRoot = () => document.querySelector('[data-lp4-side-navigation-root]')
    const getStickyNav = () => getRoot()?.querySelector('[data-lp4-nav-kind="sticky"]')
    const getStickySpacer = () => getRoot()?.querySelector('.lp4-secondary-nav__spacer')
    const getOverview = () => getRoot()?.querySelector('[data-lp4-nav-overview]')
    const selectorToId = (selector) => {
      if (!selector) return ''
      const firstChar = selector.charAt(0)
      if (firstChar === '#' || firstChar === '.') return selector.slice(1)
      return /^[A-Za-z][A-Za-z0-9_-]*$/.test(selector) ? selector : ''
    }

    const isPinnedHeader = (node) => {
      if (!node) return false
      const style = getComputedStyle(node)
      if (style.display === 'none' || style.visibility === 'hidden') return false
      return style.position === 'fixed' || style.position === 'sticky'
    }

    const getHeaderHeight = () => {
      const header = document.querySelector('.shopify-section--header, #shopify-section-header')
      const rootStyle = getComputedStyle(document.documentElement)
      const stickyHeaderEnabled =
        Number.parseFloat(rootStyle.getPropertyValue('--sticky-header-enabled')) > 0
      const headerVisibility = rootStyle.getPropertyValue('--header-is-visible').trim()
      const headerIsVisible =
        headerVisibility === '' || Number.parseFloat(headerVisibility) > 0

      if (!stickyHeaderEnabled || !headerIsVisible || !isPinnedHeader(header)) return 0

      const headerBottom = header.getBoundingClientRect().bottom
      return Number.isFinite(headerBottom)
        ? Math.max(0, Math.min(window.innerHeight, headerBottom))
        : 0
    }

    const syncStickyTop = () => {
      const headerHeight = getHeaderHeight()
      const sticky = getStickyNav()
      const stickyBottom =
        sticky && getComputedStyle(sticky).display !== 'none'
          ? sticky.getBoundingClientRect().bottom
          : headerHeight
      document.documentElement.style.setProperty('--lp4-secondary-nav-top', `${headerHeight}px`)
      document.documentElement.style.setProperty(
        '--lp4-secondary-nav-mobile-top',
        `${headerHeight}px`,
      )
      document.documentElement.style.setProperty(
        '--lp4-secondary-nav-dropdown-top',
        `${Math.max(0, stickyBottom)}px`,
      )
      return headerHeight
    }

    const getOffset = () => {
      const headerHeight = syncStickyTop()
      const sticky = getStickyNav()
      const stickyHeight =
        sticky && getComputedStyle(sticky).display !== 'none'
          ? sticky.getBoundingClientRect().height
          : 0
      return headerHeight + stickyHeight + 16
    }

    const updateStickyState = () => {
      const sticky = getStickyNav()
      const spacer = getStickySpacer()
      const visible = sticky && getComputedStyle(sticky).display !== 'none'
      const stuck = Boolean(visible && window.scrollY >= stickyStart)
      const pairs = getPairs()
      const lastTarget = pairs.length ? pairs[pairs.length - 1].target : null
      const lastBottom = lastTarget
        ? lastTarget.getBoundingClientRect().bottom + window.scrollY
        : Number.POSITIVE_INFINITY
      const footerTarget = document.querySelector('footer, .footer')
      const footerTop = footerTarget
        ? footerTarget.getBoundingClientRect().top + window.scrollY
        : Number.POSITIVE_INFINITY
      const sideMarker = window.scrollY + window.innerHeight * 0.5
      const firstTarget = pairs.length ? pairs[0].target : null
      const firstTop = firstTarget
        ? firstTarget.getBoundingClientRect().top + window.scrollY
        : Number.NEGATIVE_INFINITY
      const afterFirst = sideMarker >= firstTop
      const beforeFooter = sideMarker < Math.min(lastBottom, footerTop)
      const overHiddenSection = sideHiddenSelectors.some((selector) => {
        const target = document.querySelector(selector)
        if (!target) return false
        const rect = target.getBoundingClientRect()
        const top = rect.top + window.scrollY
        const bottom = rect.bottom + window.scrollY
        return sideMarker >= top && sideMarker <= bottom
      })

      if (sticky) sticky.classList.toggle('is-stuck', stuck)
      if (spacer) spacer.classList.toggle('is-active', stuck)
      syncStickyTop()
      ;(getRoot()?.querySelectorAll('[data-lp4-nav-kind="side"]') || []).forEach((nav) => {
        nav.classList.toggle(
          'is-visible',
          stuck && afterFirst && beforeFooter && !overHiddenSection,
        )
      })
    }

    const measureStickyStart = () => {
      const sticky = getStickyNav()
      const spacer = getStickySpacer()
      const headerHeight = syncStickyTop()

      if (!sticky || getComputedStyle(sticky).display === 'none') {
        stickyStart = Number.POSITIVE_INFINITY
        updateStickyState()
        return
      }

      const wasStuck = sticky.classList.contains('is-stuck')
      if (wasStuck) {
        sticky.classList.remove('is-stuck')
        if (spacer) spacer.classList.remove('is-active')
      }

      stickyStart = sticky.getBoundingClientRect().top + window.scrollY - headerHeight

      if (wasStuck) {
        sticky.classList.add('is-stuck')
        if (spacer) spacer.classList.add('is-active')
      }

      updateStickyState()
    }

    const getPairs = () => {
      const selectors = []
      ;(getRoot()?.querySelectorAll('[data-lp4-side-nav-target]') || []).forEach((button) => {
        const selector = button.dataset.lp4SideNavTarget
        if (selector && !selectors.includes(selector)) selectors.push(selector)
      })

      return selectors
        .map((selector) => {
          const target = resolveTarget(selector)
          const targetId = selectorToId(selector)
          if (target && targetId && !target.id && !document.getElementById(targetId)) {
            target.id = targetId
          }
          return { selector, target }
        })
        .filter((item) => item.target)
        .sort((a, b) => {
          const aTop = a.target.getBoundingClientRect().top + window.scrollY
          const bTop = b.target.getBoundingClientRect().top + window.scrollY
          return aTop - bTop
        })
    }

    const setActive = (selector) => {
      let theme = 'light'
      let activeDropdown = false
      ;(getRoot()?.querySelectorAll('[data-lp4-side-nav-target]') || []).forEach((button) => {
        const active = button.dataset.lp4SideNavTarget === selector
        button.classList.toggle('is-active', active)
        if (active) {
          button.setAttribute('aria-current', 'true')
        } else {
          button.removeAttribute('aria-current')
        }
        if (active && button.closest('[data-lp4-secondary-nav-dropdown-list]')) {
          activeDropdown = true
        }
        if (active && button.dataset.lp4SideNavTheme === 'dark') theme = 'dark'
      })
      getRoot()
        ?.querySelectorAll('.lp4-secondary-nav__overview-summary')
        .forEach((summary) => {
          summary.classList.toggle('is-active', activeDropdown)
        })
      ;(getRoot()?.querySelectorAll('[data-lp4-side-nav]') || []).forEach((nav) => {
        nav.classList.toggle('is-dark', theme === 'dark')
      })
      syncActiveIntoView(selector)
    }

    const isElementVisible = (element) =>
      Boolean(
        element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length),
      )

    const getActiveScrollContainer = (container) => {
      if (!container) return null
      if (container.matches('[data-lp4-secondary-nav-list]')) {
        return container.closest('.lp4-secondary-nav__inner') || container
      }
      return container
    }

    const scrollButtonToCenter = (button, scrollContainer, behavior) => {
      if (!button || !isElementVisible(scrollContainer)) return
      const buttonRect = button.getBoundingClientRect()
      const containerRect = scrollContainer.getBoundingClientRect()
      if (!buttonRect.width || !containerRect.width) return

      const targetLeft =
        scrollContainer.scrollLeft +
        buttonRect.left -
        containerRect.left -
        (containerRect.width - buttonRect.width) / 2
      const maxLeft = Math.max(0, scrollContainer.scrollWidth - scrollContainer.clientWidth)

      scrollContainer.scrollTo({
        left: Math.min(maxLeft, Math.max(0, targetLeft)),
        behavior,
      })
    }

    const syncActiveIntoView = (selector) => {
      const root = getRoot()
      if (!root || !selector) return
      syncStickyTop()
      const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      const behavior = motionReduced ? 'auto' : 'smooth'
      const containers = root.querySelectorAll(
        '[data-lp4-secondary-nav-list], [data-lp4-secondary-nav-dropdown-list]',
      )
      containers.forEach((container) => {
        const activeButton = Array.from(
          container.querySelectorAll('[data-lp4-side-nav-target]'),
        ).find((button) => button.dataset.lp4SideNavTarget === selector)
        if (!activeButton) return
        scrollButtonToCenter(activeButton, getActiveScrollContainer(container), behavior)
      })
    }

    const updateActive = () => {
      scrollTicking = false
      updateStickyState()
      if (clickLockTarget) {
        setActive(clickLockTarget)
        return
      }

      const pairs = getPairs()
      if (pairs.length === 0) return

      const doc = document.documentElement
      if (window.scrollY + window.innerHeight >= doc.scrollHeight - 12) {
        setActive(pairs[pairs.length - 1].selector)
        return
      }

      const marker = window.scrollY + getOffset() + 4
      let active = pairs[0]
      pairs.forEach((pair) => {
        const top = pair.target.getBoundingClientRect().top + window.scrollY
        if (top <= marker) active = pair
      })
      setActive(active.selector)
    }

    const requestUpdate = () => {
      if (scrollTicking) return
      scrollTicking = true
      updateFrame = window.requestAnimationFrame(updateActive)
    }

    const onClick = (event) => {
      const button = event.target.closest('[data-lp4-side-nav-target]')
      if (!button || !getRoot()?.contains(button)) return

      const selector = button.dataset.lp4SideNavTarget
      const target = resolveTarget(selector)
      if (!target) return
      event.preventDefault()
      getOverview()?.removeAttribute('open')

      const top = target.getBoundingClientRect().top + window.scrollY - getOffset()
      clickLockTarget = selector
      setActive(selector)
      window.clearTimeout(clickLockTimer)
      clickLockTimer = window.setTimeout(() => {
        clickLockTarget = ''
        updateActive()
      }, 2200)

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      window.scrollTo({ top: Math.max(0, top), behavior: reducedMotion ? 'auto' : 'smooth' })
    }

    const cleanup = () => {
      if (!initialized) return
      initialized = false
      controller?.abort()
      controller = null
      window.cancelAnimationFrame(updateFrame)
      window.clearTimeout(clickLockTimer)
      window.clearTimeout(firstMeasureTimer)
      window.clearTimeout(secondMeasureTimer)
      clickLockTarget = ''
      scrollTicking = false
      const root = getRoot()
      root?.querySelectorAll('[data-lp4-side-nav]').forEach((nav) => {
        delete nav.dataset.lp4SideNavReady
        nav.classList.remove('is-stuck', 'is-visible')
      })
      root?.querySelector('.lp4-secondary-nav__spacer')?.classList.remove('is-active')
      cssVariableNames.forEach((name) => {
        const value = originalCssVariables.get(name)
        if (value) document.documentElement.style.setProperty(name, value)
        else document.documentElement.style.removeProperty(name)
      })
      if (root) delete root['lp4SideNavigationCleanup']
    }

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-lp4-side-nav]').forEach((nav) => {
        if (nav.dataset.lp4SideNavReady === 'true') return
        nav.dataset.lp4SideNavReady = 'true'
        const overview = nav.querySelector('.lp4-secondary-nav__overview')
        overview?.addEventListener('toggle', () => {
          syncStickyTop()
          if (!overview.open) return
          window.requestAnimationFrame(() => {
            const activeButton = nav.querySelector('[data-lp4-side-nav-target].is-active')
            if (activeButton?.dataset.lp4SideNavTarget) {
              syncActiveIntoView(activeButton.dataset.lp4SideNavTarget)
            }
          })
        })
      })

      if (initialized) {
        updateActive()
        return
      }

      initialized = true
      controller = new AbortController()
      const root = getRoot()
      if (root) root['lp4SideNavigationCleanup'] = cleanup
      document.addEventListener('click', onClick, { signal: controller.signal })
      window.addEventListener('scroll', requestUpdate, {
        passive: true,
        signal: controller.signal,
      })
      window.addEventListener(
        'resize',
        () => {
          measureStickyStart()
          requestUpdate()
        },
        { signal: controller.signal },
      )
      window.addEventListener(
        'load',
        () => {
          measureStickyStart()
          requestUpdate()
        },
        { once: true, signal: controller.signal },
      )
      measureStickyStart()
      updateActive()
      firstMeasureTimer = window.setTimeout(() => {
        measureStickyStart()
        requestUpdate()
      }, 800)
      secondMeasureTimer = window.setTimeout(() => {
        measureStickyStart()
        requestUpdate()
      }, 2200)
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(), { once: true })
    } else {
      initAll()
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target))
    document.addEventListener('shopify:section:unload', (event) => {
      const root = getRoot()
      if (root && event.target.contains(root)) cleanup()
    })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp4-spec"] && !Shopify.designMode) return;
  try {
    
  ;(() => {
    const init = (root) => {
      if (!root) return
      root['lp4SpecCleanup']?.()

      const controller = new AbortController()
      root.dataset.lp4SpecReady = 'true'

      root.querySelectorAll('[data-lp4-spec-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const expanded = root.getAttribute('data-lp4-spec-state') === 'expanded'

          root.setAttribute('data-lp4-spec-state', expanded ? 'collapsed' : 'expanded')
          button.setAttribute('aria-expanded', expanded ? 'false' : 'true')
        }, { signal: controller.signal })
      })

      root['lp4SpecCleanup'] = () => {
        controller.abort()
        delete root.dataset.lp4SpecReady
        delete root['lp4SpecCleanup']
      }

      document.addEventListener(
        'shopify:section:unload',
        (event) => {
          if (event.target.contains(root)) root['lp4SpecCleanup']?.()
        },
        { signal: controller.signal },
      )
    }

    const initAll = (scope = document) => {
      scope.querySelectorAll('[data-lp4-spec]').forEach(init)
    }

    initAll()

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target)
    })
  })()

  } catch(e) { console.error(e); }
})();
})();
